/*!
 * bb-dd-ratings.js — BarrierBoss mega-menu aggregate star ratings (STAGED)
 * Injects a compact "★★★★★ 4.9 (88)" rating under each mega-menu
 * category TILE label (desktop .bb-dd-tile + mobile .bb-mob-tile).
 *
 * Tile matching (in order): (1) the /collections/<handle> in the tile href
 * (matches "Shop All" tiles), then (2) the handleized tile LABEL text — because
 * subcategory tiles link to individual /products/... not collections, so the
 * label (== the collection title, e.g. "Black Hog Wire Fence Panels") is the
 * only key that resolves them. Map is keyed by BOTH handle and handleized title.
 *
 * SAFE: touches ONLY tiles inside the mega-menu; idempotent (data attr guard);
 * bails gracefully when the map/key/label is missing. Self-injects scoped CSS.
 * One file, both stores — picks the map by Shopify.shop / hostname.
 *
 * Data source: collection_ratings.json (reviews >= 5) + PRODUCTS map (per-product
 * reviews.rating/rating_count, n>=1) so PRODUCT tiles show their own rating.
 * Generated — do not hand-edit the RATINGS blocks.
 */
(function () {
  'use strict';

  var RATINGS = {
    // 2cnwen-jb.myshopify.com  (USA)
    'usa': {"collections":{"a":5,"n":29},"featured-products":{"a":4.8,"n":209},"featured-fence-collection":{"a":4.9,"n":336},"all":{"a":4.9,"n":407},"metal-roofing":{"a":5,"n":4},"metal-siding":{"a":5,"n":4},"corrugated-metal-fence-panels-1":{"a":5,"n":114},"metal-fencing":{"a":4.9,"n":39},"hog-fencing":{"a":4.8,"n":266},"premium-welded-mesh-panels-commercial-industrial-fencing-solutions":{"a":4.8,"n":264},"ribbed-metal-fencing":{"a":5,"n":11},"privacy-fence":{"a":5,"n":116},"landscaping":{"a":5,"n":8},"hog-wire-deck-railing":{"a":4.3,"n":24},"fencing-accessories":{"a":4.3,"n":12},"gates":{"a":4.1,"n":18},"firesafe-metal-fence-kits":{"a":4.9,"n":39},"cattle-panel":{"a":4,"n":2},"black-hog-wire-fence-panels":{"a":4.8,"n":186},"silver-hog-wire-fence-panels":{"a":5,"n":66},"treated-framed-metal-panels":{"a":5,"n":66},"unframed-corrugated-metal-fence-sheets":{"a":4.9,"n":26},"diy-complete-kits":{"a":4.9,"n":38},"deep-groove-ribbed-fence-panels":{"a":5,"n":4},"high-wind-wood-metal-hybrid-fence-panels":{"a":5,"n":6},"corrugated-privacy":{"a":5,"n":94},"specialty-products":{"a":4.9,"n":29},"metal-roofing-siding":{"a":4.9,"n":34},"shop-the-look-featured-collection":{"a":4.8,"n":186},"metal-sheets":{"a":4.9,"n":26}},
    // barrier-boss.myshopify.com  (CA)
    'ca': {"metal-roofing":{"a":5,"n":1},"metal-siding":{"a":5,"n":2},"collections":{"a":4.9,"n":34},"hog-fencing":{"a":4.9,"n":128},"corrugated-metal-fence-panels-1":{"a":4.9,"n":95},"metal-fencing":{"a":4.9,"n":230},"landscaping":{"a":5,"n":5},"all":{"a":4.9,"n":235},"featured-fence-collection":{"a":4.9,"n":177},"premium-welded-mesh-panels-commercial-industrial-fencing-solutions":{"a":4.9,"n":122},"ribbed-metal-fencing":{"a":4.9,"n":6},"fencing-accessories":{"a":4.6,"n":15},"gates":{"a":4.3,"n":9},"hog-wire-deck-railing":{"a":3.9,"n":6},"metal-fence-posts":{"a":4.6,"n":15},"corten-rust":{"a":5,"n":1},"firesmart®-metal-fencing":{"a":4.9,"n":41},"firesmart®-metal-fence-posts":{"a":5,"n":6},"metal-sheets":{"a":4.9,"n":33},"diy-fence-kits":{"a":4.8,"n":36},"specialty-products":{"a":5,"n":5}}
  };

  // ---- pick the per-store map -------------------------------------------
  function pickStore() {
    var shop = '';
    try { if (window.Shopify && Shopify.shop) shop = String(Shopify.shop).toLowerCase(); } catch (e) {}
    if (shop.indexOf('barrier-boss') > -1) return 'ca';
    if (shop.indexOf('2cnwen-jb') > -1) return 'usa';
    var h = (location.hostname || '').toLowerCase();
    if (h.indexOf('barrierboss.ca') > -1 || h.indexOf('barrier-boss') > -1) return 'ca';
    return 'usa';
  }
  var MAP = RATINGS[pickStore()] || {};

  // ---- PRODUCT-level ratings (each product tile shows its OWN reviews) ----
  // Additive: product-handle match takes precedence over collection borrow.
  // Generated from reviews.rating / reviews.rating_count (n>=1). Do not hand-edit.
    var PRODUCTS = {
    usa: {"custom-length-metal-fencing-sheets":{"a":3,"n":1},"wood-fence-posts":{"a":4,"n":9},"brown-hog-wire-fence-panel-gauge-6-coffee-brown-hog-panels-premade-or-unframed-the-tough-panel":{"a":5,"n":6},"hog-wire-gates-rigid-black-hog-wire-gauge-6":{"a":4.1,"n":7},"corten-steel-fence-panels-7-8s-corten-weathering-steel-fence":{"a":5,"n":3},"hog-wire-deck-railing":{"a":4.6,"n":5},"the-tough-panel-silver-hog-wire-fence-panel-gauge-6-silver-hog-wire-fence-framed-or-unframe":{"a":5,"n":66},"the-fort-knox-one-person-assembly-metal-fencing-solution":{"a":5,"n":6},"metal-fence-posts-for-wood-fence":{"a":5,"n":2},"metal-planters":{"a":5,"n":8},"western-red-cedar-wood-retired-row":{"a":5,"n":2},"diy-metal-fence-kit-corrugated-metal-and-wood":{"a":4,"n":2},"pressure-treated-wood-for-fencing-retired-row":{"a":4.9,"n":19},"deep-groove-metal-fence-panels":{"a":5,"n":4},"hog-wire-fence-panels":{"a":4.8,"n":186},"deep-grove-metal-roofing":{"a":5,"n":2},"black-frame-metal-privacy-fence-kit":{"a":5,"n":7},"western-red-cedar-privacy-fence-panels":{"a":5,"n":4},"corrugated-metal-fence":{"a":5,"n":62},"classic-rib-metal-roofing-sheets":{"a":5,"n":2},"corrugated-steel-fence-panels":{"a":5,"n":25},"matte-black-corrugated-metal-siding-sheet-7-8-gauge-26":{"a":5,"n":4},"black-steel-hog-panel-track-kit-multiple-sizes-for-hog-wire-mesh-panels-3x6-to-8x8":{"a":5,"n":1},"black-cattle-panel-fence-cattle-panels-premade-or-unframed-the-angus":{"a":3,"n":1},"samples":{"a":5,"n":1},"316-stainless-steel-wire-fence-panels":{"a":2,"n":1}},
    ca: {"matte-black-corrugated-metal-siding-sheet-7-8-gauge-26":{"a":5,"n":2},"corrugated-steel-fence-panels":{"a":4.9,"n":28},"corrugated-metal-fence":{"a":5,"n":42},"western-red-cedar-privacy-fence-panels":{"a":4.8,"n":8},"black-frame-metal-privacy-fence-kit":{"a":5,"n":4},"deep-grove-metal-roofing":{"a":5,"n":1},"hog-wire-fence-panels":{"a":4.9,"n":85},"deep-groove-metal-fence-panels":{"a":5,"n":2},"pressure-treated-wood-for-fencing-retired-row":{"a":4.9,"n":10},"diy-metal-fence-kit-corrugated-metal-and-wood":{"a":4.3,"n":3},"western-red-cedar-wood-retired-row":{"a":5,"n":1},"metal-planters":{"a":5,"n":5},"metal-fence-posts-for-wood-fence":{"a":5,"n":1},"the-fort-knox-one-person-assembly-metal-fencing-solution":{"a":5,"n":3},"metal-fence-toppers":{"a":5,"n":2},"the-tough-panel-silver-hog-wire-fence-panel-gauge-6-silver-hog-wire-fence-framed-or-unframe":{"a":5,"n":34},"hog-wire-deck-railing":{"a":5,"n":1},"corten-steel-fence-panels-7-8s-corten-weathering-steel-fence":{"a":5,"n":1},"the-frontier-ribbed-sheet-metal-fence-panels-with-dualcoat-unframed":{"a":4.8,"n":4},"fence-post-caps":{"a":4.3,"n":3},"hog-wire-gates-rigid-black-hog-wire-gauge-6":{"a":4.3,"n":4},"corrugated-metal-gates-metal-fence-gates":{"a":4.3,"n":4},"brown-hog-wire-fence-panel-gauge-6-coffee-brown-hog-panels-premade-or-unframed-the-tough-panel":{"a":5,"n":1},"gates-for-full-metal-fence-kit":{"a":4,"n":1},"wood-fence-posts":{"a":4.7,"n":11},"custom-length-metal-fencing-sheets":{"a":4,"n":1},"black-steel-hog-panel-track-kit-multiple-sizes-for-hog-wire-mesh-panels-3x6-to-8x8":{"a":1,"n":1},"hog-wire-fence-kit":{"a":5,"n":1}}
  };
  var PMAP = PRODUCTS[pickStore()] || {};

  // ---- scoped CSS (inject once) -----------------------------------------
  function injectCSS() {
    if (document.getElementById('bb-dd-rating-css')) return;
    var css =
      '.bb-dd-rating{display:flex;align-items:center;gap:5px;margin-top:3px;line-height:1;' +
        'font-family:var(--font-stack-navigation,"Instrument Sans",sans-serif);}' +
      '.bb-dd-rating .bb-dd-stars{position:relative;display:inline-block;font-size:11px;letter-spacing:.5px;' +
        'white-space:nowrap;height:1em;}' +
      '.bb-dd-rating .bb-dd-stars-off{color:#dcdcdc;}' +
      '.bb-dd-rating .bb-dd-stars-on{position:absolute;top:0;left:0;overflow:hidden;color:#f5a623;}' +
      '.bb-dd-rating .bb-dd-rnum{font-size:11px;font-weight:700;color:#333;}' +
      '.bb-dd-rating .bb-dd-rcnt{font-size:10.5px;font-weight:500;color:#8a8a8a;}' +
      /* mobile tiles have dark labels on white cards too, keep count muted but legible */
      '.bb-mob-tile .bb-dd-rating{margin:5px 9px 6px;}' +
      '.bb-mob-tile .bb-dd-rating .bb-dd-rnum{color:#222;}';
    var s = document.createElement('style');
    s.id = 'bb-dd-rating-css';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  // ---- build the rating element -----------------------------------------
  function buildEl(rec) {
    var pct = Math.max(0, Math.min(100, (rec.a / 5) * 100));
    var wrap = document.createElement('span');
    wrap.className = 'bb-dd-rating';
    wrap.setAttribute('aria-label', 'Rated ' + rec.a + ' out of 5 from ' + rec.n + ' reviews');
    var stars = document.createElement('span');
    stars.className = 'bb-dd-stars';
    var off = document.createElement('span');
    off.className = 'bb-dd-stars-off';
    off.textContent = '★★★★★';
    var on = document.createElement('span');
    on.className = 'bb-dd-stars-on';
    on.style.width = pct.toFixed(1) + '%';
    on.textContent = '★★★★★';
    on.setAttribute('aria-hidden', 'true');
    off.setAttribute('aria-hidden', 'true');
    stars.appendChild(off);
    stars.appendChild(on);
    var num = document.createElement('span');
    num.className = 'bb-dd-rnum';
    num.textContent = rec.a.toFixed(1);
    var cnt = document.createElement('span');
    cnt.className = 'bb-dd-rcnt';
    cnt.textContent = '(' + rec.n + ')';
    wrap.appendChild(stars);
    wrap.appendChild(num);
    wrap.appendChild(cnt);
    return wrap;
  }

  // ---- key extraction ----------------------------------------------------
  // Shopify-style handleize — must mirror the build-time handleize().
  function handleize(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function handleFromProductHref(href) {
    if (!href) return null;
    var m = /\/products\/([^\/?#]+)/.exec(href);
    if (!m) return null;
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }
  function handleFromHref(href) {
    if (!href) return null;
    var m = /\/collections\/([^\/?#]+)/.exec(href);
    if (!m) return null;
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }

  // ---- inject into one tile anchor --------------------------------------
  function injectOne(a) {
    if (!a || a.getAttribute('data-bb-rated')) return;
    a.setAttribute('data-bb-rated', '1'); // mark regardless to avoid rescanning
    var lbl = a.querySelector('.bb-dd-tile-lbl, .bb-mob-tile-lbl');
    // 1) collection handle in the href ("Shop All" tiles), else
    // 2) handleized tile label (subcategory tiles link to /products/, so the
    //    label == collection title is the resolving key).
    var h1 = handleFromHref(a.getAttribute('href'));
    var h2 = lbl ? handleize(lbl.textContent) : null;
    // product tiles link to /products/<handle>; prefer the product's OWN rating
    var ph = handleFromProductHref(a.getAttribute('href'));
    var rec = (ph && PMAP[ph]) || (h1 && MAP[h1]) || (h2 && MAP[h2]) || null;
    if (!rec) return;
    var el = buildEl(rec);
    if (lbl && lbl.parentNode) lbl.parentNode.insertBefore(el, lbl.nextSibling);
    else a.appendChild(el);
  }

  // All mega-menu tile anchors (both link types) — matching happens in injectOne.
  var SEL = 'li.bb-dd-tile > a, li.bb-mob-tile > a';
  function scan(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) injectOne(nodes[i]);
  }

  // ---- boot --------------------------------------------------------------
  function boot() {
    injectCSS();
    scan(document);

    // Safety re-scan on menu interaction (covers any late/dynamic render).
    var raf = false;
    function reScan() {
      if (raf) return;
      raf = true;
      (window.requestAnimationFrame || setTimeout)(function () { raf = false; scan(document); }, 0);
    }
    ['mouseover', 'focusin', 'click', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.bb-dd-nav, .bb-mob-root')) reScan();
      }, { passive: true });
    });

    // Observer safety — watch BOTH the desktop nav AND the mobile drawer
    // (idempotent injectOne means no loop). Previously only .bb-dd-nav was
    // observed, so the mobile drawer got no re-scan coverage.
    try {
      if (window.MutationObserver) {
        var hosts = [
          document.querySelector('.bb-dd-nav'),
          document.querySelector('.bb-mob-root'),
          document.getElementById('MobileNav')
        ];
        var obs = new MutationObserver(reScan);
        for (var i = 0; i < hosts.length; i++) {
          if (hosts[i]) obs.observe(hosts[i], { childList: true, subtree: true });
        }
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
